import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainButton } from 'elements/button/MainButton';
import { ImageMask } from 'elements/visual/ImageMask';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { EFonts, EGrads } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    title: string;
    icon: IconName;
    text: string;
    buttonText: string;
    buttonAction: () => void;
    className?: string;
}

export const MinutePromotion = (props: Props): JSX.Element => {
    return (
        <S_MinutePromotion className={props.className} {...ANIMATION_APPEAR}>
            <S_Row>
                <S_Col>
                    <S_Icon icon={['fal', props.icon]} />
                </S_Col>
                <S_Col>
                    <S_Title>{props.title}</S_Title>
                    <S_Text>{props.text}</S_Text>
                </S_Col>
            </S_Row>
            <S_MidButton>
                <MainButton type="primary2" onClick={props.buttonAction}>
                    {props.buttonText}
                </MainButton>
            </S_MidButton>
            <ImageMask randomizePosition={true} step={20} image="contour" repeat={true} />
        </S_MinutePromotion>
    );
};

const S_MinutePromotion = styled(motion.div)`
    display: flex;
    width: 300px;
    border-radius: 7px;
    position: relative;
    flex-direction: column;
    background: ${EGrads.ACC2_GRAD};
    padding: 15px 20px;
`;

const S_Row = styled.div`
    display: flex;
`;

const S_Col = styled.div``;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: white;
    margin: 0 15px 0 0;
`;

const S_Title = styled.div`
    font-size: 14px;
    color: white;
    font-family: ${EFonts.Medium};
    margin: 0px 0 10px 0;
`;

const S_Text = styled.div`
    font-size: 13px;
    color: white;
    font-family: ${EFonts.Regular};
    line-height: 22px;
    margin: 0 0 10px 0;
`;

const S_MidButton = styled.div`
    display: flex;
    justify-content: center;
    margin: 5px 0;
`;
